import axios from "axios";
import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { useDispatch } from "react-redux";
import { addTag } from "../../Redux/Reducer/FormSlices";
import ReactModal from "react-modal";

const Addtag = ({ isOpen, cancel, createTag }) => {
  const [formattedDate, setFormattedDate] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [tagName, setTagName] = useState("");
  const [tagDescription, setTagDescription] = useState("");
  const [selectedIconName, setSelectedIconName] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = today.getFullYear();
    console.log();
    const formatted = `${day}/${month}/${year}`; // Format as dd/mm/yyyy
    setFormattedDate(formatted);
  }, []);

  const tagColorArray = [
    "#6200EE",
    "#039BE6",
    "#EC773F",
    "#E60303",
    "#18A915",
    "#008080",
    "#8E008B",
    "#F6BF26",
    "#616161",
    "#7986CB",
    "#F4511E",
  ];
  const handleSetColor = (selectedColor) => {
    setSelectedColor(selectedColor);
  };

  //Tag color get for background
  function hexToRGBA(hex, opacity) {
    // Remove the "#" if present
    hex = hex.replace("#", "");

    // Parse the r, g, b values from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Return the rgba string with the specified opacity
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  const addTagToRedux = (selectedTag) => {
    dispatch(addTag({ selectedTag }));
  };
  const handelCreateTag = async (e) => {
    e.preventDefault();
    try {
      const selectedTag = {
        tagName: tagName,
        tagDescription: tagDescription,
        tagColor: selectedColor,
        tagIcon: selectedIconName,
      };
      const responses = await axios.post(
        `${process.env.REACT_APP_API}/tag`,
        selectedTag
      );
      console.log(responses.data);
      if (responses.data.status) {
        createTag();
        addTagToRedux(responses.data.createdTag);
      }

      // .then(
      //   (data) =>
      //     data.data.status &&
      //     (createTag(), addTagToRedux(data.data.createdTag))
      // );
    } catch (error) {
      console.log(error);
    }
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      // marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      // width: "40%",
      // height: "70%",
      display: "flex",
      flexDirection: "column",
      gap: "2rem",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  if (!isOpen) return null;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => cancel()}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="selectTagmodal-content">
        <h2>Create Tag</h2>

        <form className="addTag_form_detail">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.7rem" }}
          >
            <div className="label_name">Tag Name</div>
            <div className="tag_input_container">
              <input
                type="text"
                name="tagName"
                required
                className="label_name"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.7" }}>
            <div className="label_name">Tag Description</div>
            <div className="tag_input_container">
              <textarea
                type="text"
                name="tagDescription"
                required
                className="label_name"
                value={tagDescription}
                onChange={(e) => setTagDescription(e.target.value)}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.7" }}>
            <div className="label_name">Date</div>
            <div className="date_input">
              <input type="text" name="date" value={formattedDate} readOnly />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "0.7" }}>
            <p className="label_name">Select tag color</p>
            <ul className="tag-modal-select-colorbox">
              {tagColorArray.map((color, coloridx) => (
                <li
                  key={coloridx}
                  className="tag-modal-select-color"
                  style={{
                    border: selectedColor === color && `2px solid ${color}`,
                    padding: "0px 2px",
                  }}
                  onClick={() => handleSetColor(color, coloridx)}
                >
                  <div
                    style={{
                      backgroundColor: color,
                      width: "2.4rem",
                      height: "2.4rem",
                      borderRadius: "50%",
                    }}
                  ></div>
                </li>
              ))}
            </ul>
          </div>
          <div
            className="all_icons_container"
            // style={{ display: "flex", flexDirection: "column", gap: "0.7" }}
          >
            {Object.keys(FaIcons).map((icon, index) => {
              const IconComponent = FaIcons[icon];
              return (
                <div key={index} style={{ textAlign: "center" }}>
                  <IconComponent
                    size={40}
                    style={{
                      clipPath: "circle(50%)", // Rounds the icon itself
                      WebkitClipPath: "circle(50%)",
                      color: "#8493B2", // Icon color
                      padding: "10px", // Padding inside the clipped area
                    }}
                    onClick={() => setSelectedIconName(icon)}
                  />
                </div>
              );
            })}
          </div>
          <div
            className="tag_demo_container"
            // style={{ display: "flex", flexDirection: "column", gap: "0.7" }}
          >
            {/* {DemoTag(tagName, selectedColor)} */}
            <div
              style={{
                color: selectedColor,
                backgroundColor: hexToRGBA(selectedColor, 0.1),
              }}
              className=" demo_tag"
            >
              {selectedIconName && (
                <div style={{ textAlign: "center" }}>
                  {/* Dynamically render the selected icon using the stored name */}
                  {React.createElement(FaIcons[selectedIconName], {
                    size: 30,
                    style: { color: selectedColor, padding: "5px" },
                  })}
                </div>
              )}
              <p>{tagName}</p>
            </div>
          </div>
          <div className="tag_btn_component">
            <button className="tag_cancel_btn" onClick={cancel}>
              Cancel
            </button>
            <button className="Tag-create-btn" onClick={handelCreateTag}>
              Create{" "}
            </button>
          </div>
        </form>
      </div>
    </ReactModal>
  );
};

export default Addtag;
